import Dropzone from "@deltablot/dropzone";

// Disable auto-discover - we'll manually initialize
Dropzone.autoDiscover = false;

// Make Dropzone available globally for Alpine components
window.Dropzone = Dropzone;
